import React, { useEffect, useState } from "react";
import telomeLogo from "../../../../assets/logo/telome-logo.png";
import "./ContinueInAppPrompt.css";

const DISMISSED_KEY = "telome_continue_in_app_prompt_dismissed";
const IOS_STORE_URL = "https://apps.apple.com/us/app/telome/id6761741102";
const ANDROID_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.paulkalaitzidis.telome.modbile&pli=1";

const getMobilePlatform = () => {
  const userAgent = window.navigator.userAgent || "";
  if (/android/i.test(userAgent)) return "android";
  if (/iphone|ipad|ipod/i.test(userAgent)) return "ios";
  if (/macintosh/i.test(userAgent) && window.navigator.maxTouchPoints > 1) return "ios";
  return "";
};

const getPromptDismissed = () => {
  try {
    return window.sessionStorage.getItem(DISMISSED_KEY) === "true";
  } catch {
    return false;
  }
};

const setPromptDismissed = () => {
  try {
    window.sessionStorage.setItem(DISMISSED_KEY, "true");
  } catch {
    // Storage can be unavailable in strict browser modes; closing still works for this page load.
  }
};

const getStoreFallbackUrl = () => {
  const platform = getMobilePlatform();
  if (platform === "android") return ANDROID_STORE_URL;
  if (platform === "ios") return IOS_STORE_URL;
  return "";
};

export default function ContinueInAppPrompt() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getMobilePlatform() && !getPromptDismissed()) {
      const showTimer = window.setTimeout(() => setVisible(true), 450);
      return () => window.clearTimeout(showTimer);
    }

    return undefined;
  }, []);

  const handleStayOnWeb = () => {
    setPromptDismissed();
    setVisible(false);
  };

  const handleOpenApp = () => {
    const storeUrl = getStoreFallbackUrl();
    setVisible(false);
    if (storeUrl) window.location.href = storeUrl;
  };

  if (!visible) return null;

  return (
    <>
      <div className="continue-app-prompt-backdrop" aria-hidden="true" />
      <div className="continue-app-prompt-wrap" role="region" aria-label="Continue in the app">
        <div className="continue-app-prompt">
          <div className="continue-app-prompt-icon" aria-hidden="true">
            <img src={telomeLogo} alt="" />
          </div>

          <div className="continue-app-prompt-copy">
            <h2>Continue in the app</h2>
            <p>
              Enjoy a smoother practice experience and feedback that is
              easier to review on the go.
            </p>
          </div>

          <div className="continue-app-prompt-actions">
            <button
              className="continue-app-prompt-button continue-app-prompt-button--secondary"
              type="button"
              onClick={handleStayOnWeb}
            >
              Stay on Web
            </button>
            <button
              className="continue-app-prompt-button continue-app-prompt-button--primary"
              type="button"
              onClick={handleOpenApp}
            >
              Open App
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
